// removed by extract-text-webpack-plugin
module.exports = {"medium-grey":"#9f9f9f","light-grey":"#d4d4d4","grey":"#707070","white":"#ffffff","dark-red":"#a30000","red":"#e40000","black":"#000000","ipad":"1024px","tag":"_2tkKAciTMRXgRMY6QTc25Z","preDefined":"_3hog4DBPodyHgINTYGw36F","isDraggingOver":"_28LtlReWJtb584PD76MZ2i","isDragging":"_3ZrBmu2TYRqFK6heLLbB-u"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/elements/Tags/DraggableTags/DraggableTag/DraggableTag.css
// module id = 1169
// module chunks = 0